const fr_messages = require('./fr/messages.json')

const FRENCH_STRINGS = {
  translation: fr_messages
}

export default FRENCH_STRINGS
